import { TextFormat } from "@goodgamestudios/createjs-utilities";

import { Poker2Model } from "../../../model/Poker2Model";

import { CardRankingVO } from "./CardRankingVO";

import MovieClip = createjs.MovieClip;
import { TweenMaxGroup } from "../../helper/TweenMaxGroup";
import {Poker2LayoutManager} from "../../Poker2LayoutManager";

export class CardRankingHelp {
    /** This id will be used to represent the not selected state. **/
    public static SELECTION_NONE_ID: number = 10;

    private static TXT_FORMAT_NORMAL: TextFormat;
    private static TXT_FORMAT_HIGHLIGHT: TextFormat;
    private static RANKING: any[] = ["highcard", "pair", "twoPairs", "threeOfAKind", "straight", "flush", "fullHouse", "fourOfAKind", "straightFlush", "royalFlush", "none"];
    private static Y_POS: any[] = [183.4, 148.9, 114.4, 79.8, 45.05, 10.55, -23.95, -58.45, -92.95, -127.7];
    private _rankingVOs: any[];

    private _target: MovieClip;
    private _tween: TweenMaxGroup;
    private _rankHighlight: MovieClip;
    private _rankHighlightStartY: number;
    private _rankHighlightCurrentY: number;
    private _rankHighlightHeight: number;
    private _currentRankVO: CardRankingVO;
    private _lastRankVO: CardRankingVO;

    /**
     * Displays the card ranking help on rollover.
     * @param target Target movieclip of the help on stage.
     */
    constructor(target: MovieClip) {
        this._target = target;

        this._target.visible = false;

        this._rankHighlight = this._target.rankHighlight;
        this._rankHighlightHeight = this._rankHighlight.height;
        this._rankHighlightStartY = this._rankHighlight.y;

        this._tween = new TweenMaxGroup();

        // init vos
        this.initVOs();

        // init texts
        this.initTextFields();

        // init rank (default: nothing selected)
        this.deselectRank();
    }

    private initVOs(): void {
        this._rankingVOs = [];

        var i: number = 0;
        var len: number = 11;
        var vo: CardRankingVO;
        for (i = 0; i < len; ++i) {
            if (i <= 9) {
                vo = new CardRankingVO();
                vo.rankingId = i;
                vo.tf_label = this._target["tf_" + CardRankingHelp.RANKING[i]];
                vo.yPos = CardRankingHelp.Y_POS[i];
            }
            else {
                vo = new CardRankingVO();
                vo.rankingId = i;
            }

            this._rankingVOs.push(vo);
        }
    }

    private initTextFields(): void {
        this._target.tf_title.text = Poker2Model.languageData.getTextById("table_cardhelp_title");
        this._target.tf_subline.text = Poker2Model.languageData.getTextById("table_cardhelp_copy");

        // fill single rank labels
        var i: number = 0;
        var len: number = 10;
        for (i = 0; i < len; ++i) {
            this._target["tf_" + CardRankingHelp.RANKING[i]].text = Poker2Model.languageData.getTextById("table_cardhelp_" + i);
        }
    }

    public fadeIn(): void {
        this._target.visible = true;
        //			_tween.to( _target, { alpha:1 }, 0.2, Circular.easeOut);
    }

    public fadeOut(): void {
        this._target.visible = false;
        //			_tween.to( _target, { alpha:0 }, 0.15, Circular.easeOut,0,null,onFadeOutComplete);
    }

    private onFadeOutComplete(): void {
        this._target.visible = false;
    }

    /**
     * No selection. (hides the blue card ranking highlight)
     */
    public deselectRank(): void {
        this.updateRank(10);
    }

    /**
     * Updates the rank and shows the correct view.
     * @param rankId
     */
    public updateRank(rankId: number): void {
        this._currentRankVO = this._rankingVOs[rankId];
        this.updateRankView();
        this._lastRankVO = this._currentRankVO;
    }

    private updateRankView(): void {
        if (!this._currentRankVO) {
            this._currentRankVO = this._rankingVOs[0];
        }

        if (this._currentRankVO.rankingId < 10) {
            // show highlight
            this._rankHighlight.visible = true;

            // update highlight asset position
            this._rankHighlight.y = this._currentRankVO.yPos;

            // reset font color of the last item
            if (this._lastRankVO && this._lastRankVO.tf_label) {
                this._lastRankVO.tf_label.setTextFormat(CardRankingHelp.TXT_FORMAT_NORMAL);
            }

            // switch font color
            this._currentRankVO.tf_label.setTextFormat(CardRankingHelp.TXT_FORMAT_HIGHLIGHT);
        }
        else if (this._currentRankVO.rankingId == 10) {
            // reset font color of the last item
            if (this._lastRankVO && this._lastRankVO.tf_label) {
                this._lastRankVO.tf_label.setTextFormat(CardRankingHelp.TXT_FORMAT_NORMAL);
            }

            // hide highlight
            this._rankHighlight.visible = false;
        }

        this._target.uncache();
        this._target.doCache(0, Poker2LayoutManager.GAME_SCALE_FACTOR);
    }

    public kill(): void {
        this._tween.destroy();
    }

    public static __initialize_static_members() {
        CardRankingHelp.TXT_FORMAT_NORMAL = new TextFormat(null, null, 0x1A1A1A);
        CardRankingHelp.TXT_FORMAT_HIGHLIGHT = new TextFormat(null, null, 0xffffff);
    }
}
CardRankingHelp.__initialize_static_members();
